import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import { Field } from 'redux-form';
import registerFormFieldTypes from '../../../lib/registerFormFieldTypes';
import { required } from '../../../lib/validate';
import Typography from '../../../Typography';

class ParticipantFields extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    ticket: PropTypes.object.isRequired,
    fields: PropTypes.array.isRequired,
    foreignBuyer: PropTypes.bool.isRequired,
  };

  getValidators(field, fieldType) {
    let validators = [];

    if (field.type !== 'address' && field.required) {
      validators.push(required);
    }

    if (fieldType.validator) {
      validators.push(fieldType.validator);
    }

    return validators;
  }

  getFieldProps(fieldType, field) {
    if (field.type === 'address') {
      return { foreignBuyer: this.props.foreignBuyer };
    }

    if (field.type === 'terms') {
      return { linkText: field.data.linkText, linkAddress: field.data.linkAddress };
    }

    if (!fieldType.hasOptions) {
      return null;
    }

    if (field.type === 'radiolist' || field.type === 'checklist') {
      return { options: field.data.options };
    }

    const options = field.data.options.map(option => (
      <option value={option.value} key={option.value}>
        {option.label}
      </option>
    ));

    const placeholderOption = (
      <option value="" key="placeholder" disabled>
        {this.props.intl.formatMessage({ id: 'chooseAnOption' })}
      </option>
    );

    return { children: [placeholderOption, ...options] };
  }

  render() {
    const { classes, index, ticket, fields } = this.props;
    return (
      <div className={classes.root}>
        <Typography type="caption">
          <strong>
            <FormattedMessage id="ticketName" values={{ i: index + 1, name: ticket.name }} />
          </strong>
        </Typography>
        <div className={classes.fieldList}>
          {fields
            .filter(
              ({ ticketTypeIds }) =>
                ticketTypeIds.length === 0 || ticketTypeIds.includes(ticket.id),
            )
            .map(field => {
              const fieldType = registerFormFieldTypes[field.type];

              return (
                <Field
                  component={fieldType.component}
                  name={`tickets[${index}].person.${field.id}`}
                  key={field.id}
                  props={{
                    name: field.type,
                    icon: field.icon,
                  }}
                  label={field.label}
                  validate={this.getValidators(field, fieldType)}
                  required={field.required}
                  className={classNames(classes.field, fieldType.halfWidth && classes.halfWidth)}
                  {...this.getFieldProps(fieldType, field)}
                  {...fieldType.props}
                />
              );
            })}
        </div>
      </div>
    );
  }
}

const stylesheet = theme => ({
  root: {
    '&:not(:last-child)': {
      paddingBottom: theme.spacing.large,
    },
  },
  field: {
    position: 'relative',
    marginTop: theme.spacing.small,
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing.unit,
    },
  },
  halfWidth: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '50%',
    },
  },
});

export default compose(
  injectIntl,
  injectSheet(stylesheet),
)(ParticipantFields);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/OrderForm/ParticipantFields/ParticipantFields.js